import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
import { Users } from "./Interface";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * Every user will have cart (Quantity of all Products in Cart is set to 1 by default), wishList by default
 * */

export const users: Users[] = [
  {
    _id: 1007,
    firstName: "Admin",
    lastName: "admin",
    email: "admin@gmail.com",
    password: "Admin123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
